'use client' // Error boundaries must be Client Components

export default function Error({ error }: { error: Error & { digest?: string }; reset: () => void }) {
  console.error('Error boundary caught an error:', error)

  return (
    <div
      style={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <title>Unexpected Error has occurred</title>
      <h1 style={{ fontSize: '6rem', marginBottom: '32px', fontWeight: 600 }}>500</h1>
      <p style={{ fontSize: '3rem', margin: 0 }}>Sorry, we&rsquo;ve experienced an unexpected error.</p>
    </div>
  )
}
